import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  accent?: string; // left border color, e.g. '#5bb2d4'
  onClick?: () => void;
}

export function Card({ children, className = "", accent, onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      className={[
        "bg-white rounded-2xl shadow-sm border border-gray-100 p-4",
        onClick
          ? "cursor-pointer hover:shadow-md active:scale-[0.99] transition-all"
          : "",
        className,
      ].join(" ")}
      style={accent ? { borderLeft: `4px solid ${accent}` } : undefined}
    >
      {children}
    </div>
  );
}
